export const getQuery = () => Object.fromEntries(new URLSearchParams(window.location.search.substring(1)));
